import 'jquery'
import 'jquery-ujs'
import { init as initInputs } from "../shared/inputs"

$(() => {
  initInputs()
});
